import React from 'react';
import { KTSVG } from 'src/_metronic/helpers';

type Props = {};

const NotAllowed = (props: Props) => {
  return (
    <div className="card">
      <div className="card-body text-center">
        <div className="card-body fw-normal fs-7">
          <KTSVG path="/media/icons/duotone/General/Shield-protected.svg" className="svg-icon svg-icon-5x svg-icon-primary" />
          <p className='mt-5'>Bu sayfaya erişim izniniz bulunmamaktadır.</p>
        </div>
      </div>
    </div>
  );
};
export default NotAllowed;
